module.exports = __webpack_public_path__ + "img/artifacts.889b730b.png";